module.exports = "dist/assets/images/wk-brand-wheel-815.1877e32678f38a5ecb6c0d6a93fbf679.svg";